import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/home/home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/cooperate',
    name: 'cooperate',
    component: () => import('@/views/cooperate/cooperate.vue')
  },
  {
    path: '/course',
    name: 'course',
    component: () => import('@/views/course/course.vue')
  },
  {
    path: '/socialmedia',
    name: 'socialmedia',
    component: () => import('@/views/socialmedia/index.vue')
  },
  {
    path: '/invite',
    name: 'invite',
    component: () => import('@/views/invite/index.vue')
  },
  {
    path: '/dev/invite',
    name: 'invite',
    component: () => import('@/views/invite/index.vue')
  },
      {
    path: '/invitejt',
    name: 'invite',
    component: () => import('@/views/inviteJt/index.vue')
  },
  {
    path: '/dev/invitejt',
    name: 'invite',
    component: () => import('@/views/inviteJt/index.vue')
  },
  {
    path: '/invitejt/result',
    name: 'inviteJtResult',
    component: () => import('@/views/inviteJt/result.vue')
  },
  {
    path: '/dev/invitejt/result',
    name: 'inviteJtResult',
    component: () => import('@/views/inviteJt/result.vue')
  },
  {
    path: '/invite/result',
    name: 'inviteResult',
    component: () => import('@/views/invite/result.vue')
  },
  {
    path: '/invite/result',
    name: 'inviteResult',
    component: () => import('@/views/invite/result.vue')
  },
  {
    path: '/dev/invite/result',
    name: 'inviteResult',
    component: () => import('@/views/invite/result.vue')
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('@/views/download/index.vue')
  },
   {
    path: '/dev/download',
    name: 'download',
    component: () => import('@/views/download/index.vue')
  },
   {
    path: '/media',
    name: 'media',
    component: () => import('@/views/media/index.vue')
  },
   {
    path: '/dev/media',
    name: 'media',
    component: () => import('@/views/media/index.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
